import { useState, useEffect } from 'react'

export default function GalleryLightbox({ images, isOpen, onClose, initialIndex = 0 }) {
  const [currentIndex, setCurrentIndex] = useState(initialIndex)

  useEffect(() => {
    setCurrentIndex(initialIndex)
  }, [initialIndex, isOpen])

  // Handle keyboard navigation
  useEffect(() => {
    if (!isOpen) return

    const handleKeyDown = (e) => {
      if (e.key === 'Escape') onClose()
      if (e.key === 'ArrowRight') handleNext()
      if (e.key === 'ArrowLeft') handlePrev()
    }

    window.addEventListener('keydown', handleKeyDown)
    // Prevent body scroll when lightbox is open
    document.body.style.overflow = 'hidden'

    return () => {
      window.removeEventListener('keydown', handleKeyDown)
      document.body.style.overflow = ''
    }
  }, [isOpen, currentIndex])

  if (!isOpen || !images || images.length === 0) return null

  const handleNext = () => {
    setCurrentIndex((prev) => (prev + 1) % images.length)
  }

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev - 1 + images.length) % images.length)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/95 p-4 md:p-8 select-none">
      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-4 right-4 z-50 text-white/80 hover:text-white text-2xl p-2 cursor-pointer transition-colors"
        aria-label="Luk galleri"
      >
        <i className="fa-solid fa-xmark"></i>
      </button>

      {/* Left navigation */}
      {images.length > 1 && (
        <button
          onClick={handlePrev}
          className="absolute left-4 z-40 text-white/80 hover:text-white text-3xl p-3 cursor-pointer transition-colors bg-black/20 hover:bg-black/40 rounded-full"
          aria-label="Forrige billede"
        >
          <i className="fa-solid fa-chevron-left"></i>
        </button>
      )}

      {/* Image container */}
      <div className="relative max-w-5xl max-h-[85vh] flex flex-col items-center justify-center">
        <img
          src={images[currentIndex]}
          alt={`Billede ${currentIndex + 1}`}
          className="max-w-full max-h-[80vh] object-contain rounded-lg shadow-2xl"
        />
        
        {/* Image counter */}
        <div className="mt-4 text-white/60 text-xs font-semibold tracking-wider">
          Billede {currentIndex + 1} af {images.length}
        </div>
      </div>

      {/* Right navigation */}
      {images.length > 1 && (
        <button
          onClick={handleNext}
          className="absolute right-4 z-40 text-white/80 hover:text-white text-3xl p-3 cursor-pointer transition-colors bg-black/20 hover:bg-black/40 rounded-full"
          aria-label="Næste billede"
        >
          <i className="fa-solid fa-chevron-right"></i>
        </button>
      )}
    </div>
  )
}
